import { FileText } from "lucide-react";

const LEGAL_DOCS = [
  { href: "/legal/terms-of-service.pdf", label: "Terms of Service & Subscription Agreement" },
  { href: "/legal/cancellation-refund.pdf", label: "Cancellation & Refund Policy" },
  { href: "/legal/privacy-popia.pdf", label: "Privacy Policy & POPIA Notice" },
  { href: "/legal/contact-merchant.pdf", label: "Contact & Merchant Information" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="mt-20 border-t border-neutral-200 bg-neutral-50"
    >
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="text-[11px] font-mono-tech tracking-[0.25em] text-neutral-500 mb-6 font-bold">
          LEGAL &amp; MERCHANT INFORMATION
        </div>
        <ul className="space-y-3">
          {LEGAL_DOCS.map((doc) => (
            <li key={doc.href}>
              <a
                href={doc.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-legal-${doc.href.split("/").pop().replace(".pdf", "")}`}
                className="inline-flex items-center gap-2 text-base sm:text-lg font-display font-medium text-neutral-900 hover:text-[#FF5100] transition-colors"
              >
                <FileText size={14} className="text-neutral-400 group-hover:text-[#FF5100]" />
                {doc.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="mt-10 pt-6 border-t border-neutral-200 flex flex-wrap items-center justify-between gap-3 text-xs text-neutral-500">
          <div>© {year} Spannr · AI-powered parts sourcing for SA mechanics &amp; fleets.</div>
          <div className="font-mono-tech tracking-wider">
            Payments by PayFast · Powered by Spannr (Pty) Ltd
          </div>
        </div>
      </div>
    </footer>
  );
}
